module.exports = __webpack_public_path__ + "img/1.adbb13f6.png";